<div class="la" [ngClass]="{ active: active }" (click)="toggle()" *ngIf="show">
    <ion-icon [name]="icon"></ion-icon>
    <ion-text>{{ title }}</ion-text>
</div>
